<template>
  <div class="bm-hello">
    <van-notice-bar
      text="请注意斑马邦新版上线啦"
      left-icon="volume-o"
    />
    <van-button type="primary" size="large">入口链接</van-button>

    <van-cell-group>
      <van-field
        v-model="matchId"
        label="测试赛事ID"
        type="textarea"
        placeholder="请输入"
        rows="1"
        autosize />
      <van-field
        v-model="teamId"
        label="测试球队ID"
        type="textarea"
        placeholder="请输入"
        rows="1"
        autosize />
      <van-cell title="球队管理" is-link @click="goTeamManage()" />
      <van-cell title="报名设置" is-link @click="goSignUp()" />
      <van-cell title="赛事报名" is-link @click="goSignTeam()" />
      <van-cell title="参赛球队收集" is-link @click="goMyTeams()" />
      <van-cell title="参赛名单" is-link @click="goTeamPlayer()" />
      <van-cell title="参赛球员名单收集" is-link @click="goPlayers()" />
      <van-cell title="邀请球队完善资料" is-link to="/invite-team-edit/info?matchId=16" />
      <van-cell title="邀请球队" is-link to="/invite/team?matchId=16" />

      <van-cell title="测试goWeappPage" is-link @click="goWeappPage1()" />

    </van-cell-group>

  </div>
</template>

<script>
import Vue from 'vue'
import { goWeappPage } from '@/libs/ds-bridge'

import { Button, NoticeBar, Cell, CellGroup } from 'vant'

Vue.use(Button).use(NoticeBar).use(Cell).use(CellGroup)

export default {
  name: 'Home',
  data () {
    return {
      msg: '首页',
      matchId: 16,
      teamId: 2423
    }
  },
  created() {
  },
  methods: {
    goWeappPage1 () {
      const params = {
        appId: 'wxf8593e55c3872052',
        userName: 'gh_60da064eb791',
        path: '/page/team/matchHome/main?matchId=18'
      }
      goWeappPage(params)
    },
    goTeamManage() {
      this.$router.push({name: 'TeamManage', query: {matchId: this.matchId}})
    },
    goSignUp() {
      this.$router.push({name: 'Setting', query: {matchId: this.matchId}})
    },
    goSignTeam() {
      this.$router.push({name: 'InviteTeam', query: {matchId: this.matchId}})
    },
    goTeamPlayer() {
      this.$router.push({name: 'InviteTeamInfo', query: {matchId: this.matchId, teamId: this.teamId}})
    },
    goMyTeams() {
      this.$router.push({name: 'InviteTeamInfo', query: {matchId: this.matchId}})
    },
    goPlayers() {
      this.$router.push({name: 'NamePlayer', query: {matchId: this.matchId, teamId: this.teamId}})
    }
  }
}
</script>

<style lang="css">
  .bm-hello {
    background: white;
  }
  .bm-hello h1 {
    font-weight: normal;
    color: red;
  }
  .bm-hello .avatar img {
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue